import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { toast } from 'react-toastify';

export const deleteLecturerRateOperation = async (
  rateId: number,
  setDeleteRateId: (rateId: number | null) => void,
) => {
  try {
    setDeleteRateId(rateId);
    const res = await appApi.deleteLecturerRate(rateId);

    if (res.data.ok) {
      const settingsData = await appApi.getAllSettings();
      if (settingsData.data.ok) {
        globalSettingsStores.lecturersTypeRateNames =
          settingsData.data.body.lecturersTypeRateNames;
      }
      toast.success('סוג תשלום נמחק בהצלחה');
    }

    setDeleteRateId(null);
  } catch (error) {
    console.error('Failed to delete lecturer rate:', error);
    toast.error('שגיאה במחיקת סוג תשלום');
    setDeleteRateId(null);
  }
};
